const colors = {
  // General
  black: '#000',
  boxShadow: 'rgba(0,0,0,0.1)',
  boxShadowDark: 'rgba(0, 0, 0, 0.15)',
  strokeDark: '#DAE0E4',
  stroke: '#e4ebef',
  strokeLight: '#F4F4F5',
  strokeWater: '#E8F1F8',
  modalOverlay: 'rgba(0, 0, 0, 0.4)',
  navyOverlay: 'rgba(52,57,81,0.5)',

  // Opacities
  blueHawkes20: 'rgba(228,240,252,0.2)',
  blueHawkes50: 'rgba(228,240,252,0.5)',
  purpleSoft10: 'rgba(248,240,249,0.1)',

  // Blues
  blue: '#40aadb',
  blueHover: '#349BCB',
  blueDark: '#40aadb',
  lightBlue: '#eef3f6',
  babyBlue: '#D7E7F9',
  powderBlue: '#D9EEF8',
  buttonBorder: '#40AADB',
  navy: '#343951',
  brightBlue: '#5EA5EE',
  blueHaze: '#E9EFF3',
  bluePicton: '#4FBBE0',
  blueBlizzard: '#AADCEF',
  blueMariner: '#2E71C1',
  blueHawkes: '#e4f0fc',
  blueMystic: '#D8E2E9',
  blueHavelock: '#5698DC',
  blueZodiac: '#0B1236',
  blueJellyBean: '#257FA8',

  // Black
  black: '#231f20',
  ebony: '#252A3B',
  ebonyClay: '#2D3347',

  // Greys
  grey: '#7C7C80',
  greyMid: '#A6ACAF',
  greySoft: '#E4EBEF',
  greySofter: '#F1F4F6',
  greyLight: '#F9FAFB',
  greyPorcelain: '#F3F4F5',
  greyScorpion: '#5C5C5C',
  greyBoulder: '#767676',
  greyJumbo: '#7C7C7F',
  greyManatee: '#969699',
  greyIron: '#D2D8DC',

  // Purples
  purple: '#BA69C8',
  purpleSoft: '#F8F0F9',
  purpleLight: '#F1E1F4',
  deepPurple: '#3A3D5B',
  purpleAmethyst: '#C761CE',
  purpleWisteria: '#A55AB2',
  purpleAffair: '#974ca3',

  // Reds
  red: '#e25c59',
  redDark: '#B54A47',
  redHover: '#D05552',
  error: 'rgba(226, 92, 89 , 0.1)',
  lightRed: '#F0E9EB',
  redLinen: '#FCEEEE',

  // Greens
  green: '#34b96f',
  lightGreen: '#E1F1E7',
  greenDark: '#2B965A',
  greenHover: '#2FAC67',
  greenOcean: '#37B66E',
  greenSea: '#229053',

  // Orange
  orange: '#f0ad4e',
  warning: 'rgba(240, 173, 78, 0.1)',
  orangeSandy: '#F28F5D',
  orangeBurnt: '#E88857',
  orangeRaw: '#D07040',
  orangePink: '#FDF3EE',
  orangeDamask: '#D77644',

  // White
  white: '#fff',
  whiteCatskill: '#F2F6F9',
  whitePorcelain: '#ECEEF0',
  whiteAntiFlash: '#EEF3F6',
}

export default colors

export const hexToRgba = (color, opacity = 1) => {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i
  color = color.replace(shorthandRegex, (m, r, g, b) => r + r + g + g + b + b)

  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color)
  const rgb = result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : { r: 0, g: 0, b: 0 }
  return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${opacity})`
}
